<template>
  <section class="contact-us-outer">
    <div class="contact-us-inner">
      <ContactForm />
    </div>
  </section>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
export default {
  components: {
    ContactForm
  }
}
</script>
<style scoped lang="scss">
.contact-us-outer {
  width: 100%;
  padding: 60px 0;
  @include minWidth992 {
    padding-right: 100px;
  }
}
.contact-us-inner {
  @include InnerContainer();
}
</style>
